export default __webpack_public_path__ + "static/media/512.db68c490.jpg";